import TableHeaderCell from "./table-header-cell"
import TableHeaderRow from "./table-header-row"

const TableHeader = ({ className, columns}) => {

  return (
    <TableHeaderRow className={className}>
      {columns.map(({ key, label, align }) => (
        <TableHeaderCell
          key={key}
          className={align ?? "text-center"}
        >
          {label}
        </TableHeaderCell>
      ))}
    </TableHeaderRow>
  )
}

export default TableHeader